import React, { useEffect, useState } from "react";
import { QuestionHead, QuestionHeader } from "../styled/styles";
import styled from "styled-components";

const Container = styled.div`
  width: 100%;
  height: 65px;
  background-color: white;
  border-radius: 5px;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 1px 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;

const StyledSliderWrapper = styled.div`
  position: relative;
  width: 70%;
`;

const Tooltip = styled.div`
  position: absolute;
  top: -45px;
  left: ${(props) => props.leftPosition}%;
  transform: translateX(-50%);
  background-color: #f88434;
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  pointer-events: none;
  display: ${(props) => (props.show ? "block" : "none")};
`;

const StyledSlider = styled.input`
  width: 100%;
  appearance: none;
  height: 15px;
  background: ${(props) =>
    `linear-gradient(to right, #60c4cc ${
      (props.value / props.max) * 100
    }%, #ddd ${(props.value / props.max) * 100}%)`};
  border-radius: 10px;
  outline: none;
  transition: background 0.3s ease;
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};

  &::-webkit-slider-thumb {
    appearance: none;
    width: 30px;
    height: 30px;
    background: white;
    border: 2px solid lightgray;
    border-radius: 50%;
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
    margin-top: -8px;
    position: relative;
  }

  &::-webkit-slider-runnable-track {
    height: 15px;
    border-radius: 10px;
  }
`;

const ZeroSpan = styled.span`
  font-weight: bold;
`;

const TwentyFiveSpan = styled.span`
  font-weight: bold;
`;

const NoResponseLabel = styled.label`
  display: flex;
  align-items: center;
  margin-top: 10px;
  width: 300px;
  height: 45px;
  background-color: white;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 1px 1px 0px;
  border: 2px solid transparent;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    span {
      color: #5bc5cd;
    }
  }

  input {
    position: relative;
    width: 25px;
    height: 25px;
    appearance: none;
    border: 2px solid #ace1e5;
    border-radius: 3px;
    background-color: white;
    margin-right: 10px;
    margin-left: 10px;
    cursor: pointer;

    &:checked {
      background-color: #5bc5cd;
      border: 2px solid #5bc5cd;

      &::before {
        content: "\\2714";
        position: absolute;
        top: -7px;
        left: 1px;
        font-size: 26px;
        color: white;
      }
    }

    &:hover {
      border-color: #5bc5cd;
    }
  }

  span {
    font-size: 16px;
    color: ${(props) => (props.checked ? "#5bc5cd" : "black")};
  }

  &.checked {
    background-color: #e6f6f7;
    border: 2px solid #5bc5cd;
  }
`;

const IndividualSlider = ({errors, setErrors, currentPage, currentPageAnswers, question, sliderValueArray, setSliderValueArray, leftLabel, rightLabel, index, isChecked, minRange, maxRange, interval, answerCode, answeredQuestions, setCurrentPageAnswers, setAnsweredQuestions}) => {
  const [isThumbHovered, setIsThumbHovered] = useState(false);

  const handleMouseEnter = () => setIsThumbHovered(true);
  const handleMouseLeave = () => setIsThumbHovered(false);

  const handleSliderChange = (event) => {
            
    const newValue = parseFloat(event.target.value).toFixed(1);
    const newValueString = `${event.target.dataset.code}=${newValue}`;

    let answeredQuestionsCopy = [...answeredQuestions];

    answeredQuestionsCopy[currentPage - 1][currentPageAnswers.findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))][index] = newValueString;

    let sliderValueArrayCopy = [...sliderValueArray]
    sliderValueArrayCopy[index] = newValue;

    setSliderValueArray(sliderValueArrayCopy);
    setAnsweredQuestions(answeredQuestionsCopy);
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);


    setErrors(
      errors.filter(
        (errorExpression) => errorExpression !== question.QuestionCode
      )
    );
  };

  return (
    <>
    <br/>
    <Container disabled={isChecked}>
      <ZeroSpan>{leftLabel}</ZeroSpan>
      <StyledSliderWrapper>
        <Tooltip
          leftPosition={(sliderValueArray[index] / (maxRange - minRange)) * 100}
          show={isThumbHovered && !isChecked}
        >
          +{sliderValueArray[index]}%
        </Tooltip>
        <StyledSlider
          type="range"
          value={sliderValueArray[index]}
          min={0}
          max={maxRange - minRange}
          step={interval}
          data-code={answerCode}
          onChange={handleSliderChange}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onFocus={handleMouseEnter}
          onBlur={handleMouseLeave}
          disabled={isChecked}
        />
      </StyledSliderWrapper>
      <TwentyFiveSpan>{rightLabel}</TwentyFiveSpan>
    </Container>
    <br/>
    </>
  )
}

const IndividualCheckbox = ({currentPage, question, index, sliderValueArray, setSliderValueArray, answeredQuestions, setAnsweredQuestions, setCurrentPageAnswers, responseLabel, isChecked, setIsChecked}) => {
  const handleCheckboxChange = () => {
            
    setSliderValueArray(sliderValueArray.map((val, i) => i === index ? isChecked ? 0 : 1 : 0))

    let answeredQuestionsCopy = [...answeredQuestions]

    answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))] = answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))].map((ans, i) => i === index ? `${ans.split('=')[0]}=${isChecked ? '0' : '1'}` : `${ans.split('=')[0]}=0`)
    
            
    setAnsweredQuestions(answeredQuestionsCopy)
    setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1])
    setIsChecked(!isChecked);
  };

  return (
    <NoResponseLabel
      checked={isChecked}
      className={isChecked ? "checked" : ""}
    >
      <input
        type="checkbox"
        checked={isChecked}
        onChange={handleCheckboxChange}
      />
      <span>{responseLabel}</span>
    </NoResponseLabel>
  )
}

const Slider = ({
  toDisplay,
  currentPage,
  errors,
  setErrors,
  answeredQuestions,
  setAnsweredQuestions,
  currentPageAnswers,
  setCurrentPageAnswers,
  question
}) => {

  const [isChecked, setIsChecked] = useState((!!(answeredQuestions[currentPage - 1].length && answeredQuestions[currentPage - 1][answeredQuestions[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))]) ? answeredQuestions[currentPage - 1][answeredQuestions[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))] : null)?.filter(ans => question.Answers?.filter((ansObj, i) => ansObj.AnswerType === 'None').map(ansObj => ansObj.Expression.split('=')[0]).includes(ans.split('=')[0])).some(chosenAns => chosenAns.split('=')[1] === '1'));
          
  const [sliderValueArray, setSliderValueArray] = useState(!!(answeredQuestions[currentPage - 1].length && answeredQuestions[currentPage - 1][answeredQuestions[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))]) ? answeredQuestions[currentPage - 1][answeredQuestions[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))].map(answerString => answerString.split('=')[1]) : question.Answers.map(answer => 0))

  useEffect(() => {
                         
    let answeredQuestionsCopy = [...answeredQuestions];
    if (currentPageAnswers.length) {
      const answers = currentPageAnswers.some((pageAnswerObj) =>
        typeof pageAnswerObj === 'object' && pageAnswerObj.some(answer => answer.includes(question.Answers[0].AnswerCode))
      ) || currentPageAnswers.some(answer => answer.includes(question.Answers[0].AnswerCode));

      if (answers){
        if (currentPageAnswers.some((pageAnswerObj) =>
          typeof pageAnswerObj === 'object')) {
            answeredQuestionsCopy[currentPage - 1] = [
              ...currentPageAnswers
            ];
          } else {
            answeredQuestionsCopy[currentPage - 1] = [currentPageAnswers]
          }
      } else {
        answeredQuestionsCopy[currentPage - 1] = [
          ...currentPageAnswers,
          question.Answers.map(answer => `${answer.AnswerCode}=0`),
        ];
      }

      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      setAnsweredQuestions(answeredQuestionsCopy);

      setSliderValueArray(!!(answeredQuestionsCopy[currentPage - 1].length && answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))]) ? answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))].map(answerString => answerString.split('=')[1]) : question.Answers.map(answer => 0))

      setIsChecked((!!(answeredQuestionsCopy[currentPage - 1].length && answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))]) ? answeredQuestionsCopy[currentPage - 1][answeredQuestionsCopy[currentPage - 1].findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))] : null)?.filter(ans => question.Answers?.filter((ansObj, i) => ansObj.AnswerType === 'None').map(ansObj => ansObj.Expression.split('=')[0]).includes(ans.split('=')[0])).some(chosenAns => chosenAns.split('=')[1] === '1'))
    } else {
      answeredQuestionsCopy[currentPage - 1] = [
        question.Answers.map(answer => `${answer.AnswerCode}=0`),
      ];

      setCurrentPageAnswers(answeredQuestionsCopy[currentPage - 1]);
      setAnsweredQuestions(answeredQuestionsCopy);
    }
  }, [toDisplay, JSON.stringify(answeredQuestions[currentPage - 1][answeredQuestions.findIndex(answer => typeof answer === "object" && answer[0]?.includes(question.Answers[0].AnswerCode))])]);

  return (
    <>
      {question.Answers.map((answer, i) => {
        if (answer.AnswerType === "None") {
          return (
            <IndividualCheckbox currentPage={currentPage} question={question} index={i} sliderValueArray={sliderValueArray} setSliderValueArray={setSliderValueArray} answeredQuestions={answeredQuestions} setAnsweredQuestions={setAnsweredQuestions} setCurrentPageAnswers={setCurrentPageAnswers} responseLabel={answer.AnswerLabel} isChecked={isChecked} setIsChecked={setIsChecked}/>
          )
        } else if (answer.AnswerType === "Normal") {
          return (
            <IndividualSlider errors={errors} setErrors={setErrors} currentPage={currentPage} currentPageAnswers={currentPageAnswers} question={question} sliderValueArray={sliderValueArray} setSliderValueArray={setSliderValueArray} leftLabel={answer.LeftLabel} rightLabel={answer.RightLabel} setCurrentPageAnswers={setCurrentPageAnswers} setAnsweredQuestions={setAnsweredQuestions} index={i} answeredQuestions={answeredQuestions} isChecked={isChecked} minRange={answer.MinRange} maxRange={answer.MaxRange} interval={answer.Interval} answerCode={answer.AnswerCode} />
          )
      }})}
    </>
  );
};

// Slide Component
const Slide = ({
  currentPage,
  errors,
  setErrors,
  toDisplay,
  question,
  answeredQuestions,
  setAnsweredQuestions,
  currentPageAnswers,
  setCurrentPageAnswers,
  parseDynamicQuestionText
}) => {  
  return (
    <>
      <QuestionHead padding="0 15px">{parseDynamicQuestionText(question.QuestionHead)}</QuestionHead>
      <QuestionHeader
        padding="0 15px"
        errors={errors}
        setErrors={setErrors}
        question={question}
      >
        {parseDynamicQuestionText(question.QuestionName)}
      </QuestionHeader>
      <Slider
        toDisplay={toDisplay}
        currentPage={currentPage}
        setCurrentPageAnswers={setCurrentPageAnswers}
        currentPageAnswers={currentPageAnswers}
        question={question}
        errors={errors}
        setErrors={setErrors}
        answeredQuestions={answeredQuestions}
        setAnsweredQuestions={setAnsweredQuestions}
        questionsArray={question.Answers}
      />
    </>
  );
};

export default Slide;
